import axios from 'axios';
import { CONFIG } from './envConfig';

var api = axios.create({
  baseURL: CONFIG.API_URL,
  timeout: 120000, // 2 minutes
});

export default api;
